import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import BudgetControlCardSortBy from "./BudgetControlCardSortBy";
import { useState } from "react";
import BrandNameSearchDrawer from "../BrandNameSearchDrawer";

interface BudgetControlCardFilterProps {
  brandCount?: number;
  overuse?: boolean;
  onOveruseToggle?: (checked: boolean) => void;
  onRefresh?: () => void;
  onDownload?: () => void;
  sortKey: string;
  sortDir: "asc" | "desc";
  onApplySort: (key: string, dir: "asc" | "desc") => void;

  // Brand name search
  brandList?: string[];
  brandName?: string;
  onBrandNameChange?: (value: string) => void;
}

const BudgetControlCardFilter = ({
  brandCount = 0,
  overuse = false,
  onOveruseToggle,
  onRefresh,
  onDownload,
  sortKey,
  sortDir,
  onApplySort,
  brandList = [],
  brandName = "",
  onBrandNameChange,
}: BudgetControlCardFilterProps) => {
  const [searchOpen, setSearchOpen] = useState(false);
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.md.$value,
          color: colors.GrayLightMode[900].$value,
        }}
      >
        <Box>
          <Typography
            display={"flex"}
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Regular.$value,
            }}
          >
            Sort by:{" "}
            <BudgetControlCardSortBy
              sortKey={sortKey}
              sortDir={sortDir}
              onApply={onApplySort}
            />
          </Typography>
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              mt: spacing.Spacing.sm.$value,
            }}
          >
            {brandCount} Brands
          </Typography>
        </Box>
        <Box>
          {/* Search — opens the brand-name bottom sheet */}
          <IconButton
            data-tracker="831"
            color="secondary"
            size="large"
            onClick={() => setSearchOpen(true)}
          >
            <SearchIcon sx={{ color: colors.GrayLightMode[700].$value }} />
          </IconButton>
          <IconButton
            data-tracker="829"
            color="secondary"
            size="large"
            onClick={onDownload}
            disabled={brandCount === 0}
          >
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
          <IconButton
            data-tracker="830"
            color="secondary"
            size="large"
            onClick={onRefresh}
          >
            <RefreshIcon sx={{ color: colors.GrayLightMode[700].$value }} />
          </IconButton>
        </Box>
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: "center", py: spacing.Spacing.md.$value }}
      >
        <Typography
          sx={{
            color: colors.GrayLightMode[500].$value,
            fontSize: typography.Size.Text.xxs.$value,
            fontWeight: typography.Font_weight.Bold.$value,
          }}
        >
          Budget Overuse
        </Typography>

        <FormControlLabel
          control={
            <Switch
              data-tracker="828"
              color="secondary"
              size="small"
              checked={overuse}
              onChange={(e) => onOveruseToggle?.(e.target.checked)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: colors.Brand[600].$value,
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: colors.Brand[600].$value,
                  opacity: 0.5,
                },
                "& .MuiSwitch-track": {
                  backgroundColor: "#D0D5DD",
                  opacity: 1,
                },
              }}
            />
          }
          label=""
        />
      </Stack>
      {/* Brand Name search bottom sheet */}
      <BrandNameSearchDrawer
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        brandList={brandList}
        brandName={brandName}
        onBrandNameChange={onBrandNameChange}
      />
    </>
  );
};

export default BudgetControlCardFilter;
